import { Reveal } from "@components/ui";

const standards = [
  {
    metric: "1",
    unit: "Day",
    label: "Response Time",
    description: "All inquiries answered within one business day.",
  },
  {
    metric: "3",
    unit: "Days",
    label: "Issue Resolution",
    description: "Billing or account issues resolved within three working days.",
  },
  {
    metric: "24/7",
    unit: "",
    label: "Emergency Support",
    description: "Round-the-clock emergency assistance with certified technicians.",
  },
  {
    metric: "100",
    unit: "%",
    label: "Data Confidentiality",
    description: "Full confidentiality and data protection in all interactions.",
  },
];

export default function ServiceStandardsSection() {
  return (
    <section className="w-full bg-white py-12 md:py-16 lg:py-[100px] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto font-albert-sans">
        {/* Header */}
        <Reveal direction="up" className="text-center mb-8 md:mb-12">
          <h2 className="text-[28px] md:text-[36px] lg:text-[44px] font-semibold text-[#122d63] tracking-[-0.04em] leading-tight">
            Our Service Standards
          </h2>
          <p className="text-[15px] md:text-[18px] text-[#62636c] mt-2 md:mt-3 max-w-[550px] mx-auto">
            We are committed to providing exceptional service and support to all our customers.
          </p>
        </Reveal>

        {/* 4-column stats row */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 mb-8 md:mb-10">
          {standards.map((item, index) => (
            <Reveal key={index} direction="up" delay={index * 80} className="h-full">
              <div className="h-full rounded-[16px] border border-[rgba(98,99,108,0.12)] p-5 md:p-6 text-center hover:border-[#122d63]/20 hover:shadow-md transition-all duration-300">
                <div className="flex items-baseline justify-center gap-0.5 mb-2">
                  <span className="text-[36px] md:text-[48px] font-bold text-[#122d63] leading-none tracking-[-0.03em]">
                    {item.metric}
                  </span>
                  {item.unit && (
                    <span className="text-[18px] md:text-[22px] font-semibold text-[#122d63]/60">
                      {item.unit}
                    </span>
                  )}
                </div>
                <p className="text-[14px] md:text-[16px] font-semibold text-[#090d2c] mb-1.5">
                  {item.label}
                </p>
                <p className="text-[13px] md:text-[14px] text-[#62636c] leading-relaxed">
                  {item.description}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Quote bar */}
        <Reveal direction="up" delay={400}>
          <div className="flex items-center gap-4 md:gap-5 rounded-[14px] bg-[#f8f8f8] border-l-4 border-[#f03813] px-5 md:px-7 py-4 md:py-5">
            <svg viewBox="0 0 24 24" fill="none" className="w-7 h-7 md:w-8 md:h-8 text-[#f03813] shrink-0">
              <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z" fill="currentColor" />
              <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z" fill="currentColor" />
            </svg>
            <p className="text-[16px] md:text-[20px] text-[#090d2c] font-medium leading-snug italic">
              Your safety and satisfaction come first — every time.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
